module.exports = __webpack_public_path__ + "img/38.c7f1e3dd.gif";